























import { Component, Vue } from 'vue-property-decorator';
import ordersTable from '@/modules/orders/components/OrdersTable.vue';
import cCard from '@/components/default/Card.vue';
import PurchaseNavigation from '@/modules/shared/navigation/PurchaseNavigation.vue';

@Component({
  components: {
    ordersTable,
    cCard,
    PurchaseNavigation,
  },
})
export default class OrdersOverviewPage extends Vue {
  add() {
    (this.$refs.ordersTable as ordersTable).add();
  }
}
